<template>
    <div>
        <h1 class="mt-4">
            <a href="/scraper/">Search objekt</a> / Ladda upp
        </h1>

        <div class="content-container">
            <input type="file" @change="upload" />
        </div>
    </div>
</template>

<script>
import lister from '../../shared/mixins/lister'
import axios from 'axios'

export default {

    data () {
        return {

        }
    },

    methods: {
        upload (event) {
            const files = event.target.files || event.dataTransfer.files
            if (!files.length) { return }

            const formData = new FormData()
            formData.append('file', files[0], files[0].name)

            axios.post(
                '/scraper/upload',
                formData
            )
                .then(response => {
                    console.log('upload')
                    console.log(response.data)

                    window.location.href = '/scraper'
                })
                .catch(error => {
                    alert('Uppladdning misslyckades, vänligen försök igen.')
                })
        }
    }
}
</script>
